import React from "react";
import { Container, Image, Form} from "react-bootstrap";
import { Link } from "react-router-dom";
import {ArrowLeftIcon} from "../../assets/icons";
// import logoBlack from "../../assets/images/logo/logo-dark.png";
import LoginLogo from "../../assets/images/login/shapes/login-logo.png";
import "./Styles/Login.css";
// import { useDispatch, useSelector } from "react-redux";
import CommonButton from "../../components/commonButton";
import CommonFormLabel from "../../components/formLabel";
import Input from "../../components/input";
import { routes } from "../../routes/PageRoutes";

const ForgotPassword = () => {
  // const [showToast, setShowToast] = useState(false);
  // const [showEyeIcon, setShowEyeIcon] = useState(false);
  // const [toastMessage, setToastMessage] = useState("");
  // const [toastVariant, setToastVariant] = useState("toast-success");
  // const dispatch = useDispatch();
  // const { status, error } = useSelector((state) => state.auth);
  // const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault(e);
    // navigate(routes.verifyOtp);
  };

  return (
    <>
      <Container fluid="xxl" className="mx-auto px-4">
        <div className="d-flex align-items-center justify-content-center py-4  login-content">
          <div className="position-relative w-100 py-4 login-sub-content">
            <div className="bg-white rounded-2 p-5 common-shadow login-card">
              <h1 className="fs-5 d-flex align-content-center justify-content-center mb-4">
                <Link
                  to="https://mep.in/"
                  className=" text-decoration-none  d-inline-block"
                >
                  <Image src={LoginLogo} alt="Site-Logo" />
                </Link>
              </h1>
              <div className="mb-4 welcome-content ">
                <h4 className="mb-1 text-start">Forgot Password?</h4>
                <p className="mb-1 text-start">
                  Enter your email and we'll send you instructions to reset your
                  password.
                </p>
              </div>

              <Form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <CommonFormLabel title="Email" />
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="Enter your email"
                    // onChange={handleChange}
                    className={`shadow-none`}
                    // className={`shadow-none ${touched.email && errors.email ? 'error' : 'correct'}`}
                  />
                </div>

                <CommonButton
                  title="Send reset link"
                  type="submit"
                  className="w-100 btn-primary primary-shadow"
                />

                <div className="welcome-content d-flex align-items-center justify-content-center gap-2 mt-4">
                   <Link to={routes.login} className="text-decoration-none d-flex align-items-center justify-content-center link-title">
                    <ArrowLeftIcon
                        width={22}
                        height={22}
                        color="#9F2F48"
                        strokeWidth="2.2"
                      />
                      Back to login
                   </Link>
                     
                  
                </div>
              </Form>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default ForgotPassword;
